export const getUserById = (users, userId) => {
    const user = users.find(user => (
        user.id === userId
    ))

    return user;
}

export const getMentionableUsers = applicableUsers => {
	let userMentions = []

    applicableUsers.forEach(user => {
        const userName = user.first_name+' '+user.last_name

        const userMention = {
            text: userName,
            value: userName,
            url: '#mention-'+user.id,
            id: user.id
        }

        userMentions.push(userMention)
    })

    return userMentions
}

const statusDescriptions = {
    ONLINE: 'Ready to chat',
    AWAY: 'Away from keyboard',
    BUSY: 'Busy with something',
    OFFLINE: 'Offline'
}

export const getOnlineDotProps = (userData, isOnline) => {
    if(!userData || !isOnline){
        return null
    }

    const status = userData.status_if_online || 'ONLINE'
    const isCustom = status === 'CUSTOM'

    if(status === 'OFFLINE'){
        return null
    }

    let title = statusDescriptions[status] || status

    if(isCustom && userData.status_custom_label){
        title = userData.status_custom_description ? `${userData.status_custom_label} - ${userData.status_custom_description}` : userData.status_custom_label
    }

    return {
        className: `online-dot ${isCustom ? '' : status} visible`,
        style: isCustom ? {
            background: userData.status_custom_color,
            boxShadow: `0px 0px 10px ${userData.status_custom_color}`
        } : undefined,
        title
    }
}

export const getMeta = (user, type, account = null) => {
    if(!user){
        return null
    }

    let key = ''

    switch(type){
        case 'role':
            key = 'roles'
            break
        case 'hoursWorked':
            key = 'hours_worked'
            break
    }
    
    const accountId = account ? account.id : user.last_open_account_id

    let response = null

    if(user[key] && user[key][accountId]){
        response = user[key][accountId]
    }else{
        switch(type){
            case 'role':
                response = user.role
                break
            case 'hoursWorked':
                response = 38
                break
        }
    }

    return response
}